import { Component, inject, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { FilterItem, InternalFilterGroup } from 'app/shared/models/filter-group.models';
import { SearchSettings } from 'app/back-office/shared/models/common/search-settings.model';
import { AgencyService, GetAllAgenciesParams } from 'app/back-office/shared/services/back-office/agency.service';
import { FilterMapper } from 'app/back-office/shared/utilities/filter-mapper';
import { RolesEnum } from 'app/shared/enums/roles.enum';
import { ShopContextStore } from 'app/shared/state/shop-context.store';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';

@Component({
    selector: 'app-agency-filter',
    templateUrl: './agency-filter.component.html',
    styleUrls: ['./agency-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AgencyFilterComponent implements OnInit {
  @Input() filter: InternalFilterGroup;
  @Input() accordionState: boolean;
  loaderId = UtilityFunctions.newGuid();

  searchSettings: SearchSettings = {
    placeholder: 'Search agency...',
    inputId: UtilityFunctions.newGuid(),
    showFilters: false,
  };

  totalCount = 0;
  searchValue = '';
  cacheFilterData: FilterItem[];
  dataToView: FilterItem[] = [new FilterItem({ text: 'STATUS.ALL', value: null })];
  private _shopContext = inject(ShopContextStore);

  constructor(
    private agencyService: AgencyService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.accordionState && this.accordionState && this.dataToView.length === 1) {
      this.setDataToView(0);
    }
  }

  ngOnInit(): void {
  }


  onSearch(search: string) {
    this.searchValue = search;
    if (search === '') this.dataToView = [new FilterItem({ text: 'STATUS.ALL', value: null })];
    this.setDataToView(0);
  }

  setDataToView(skipCount: number) {
    const storeId = this._shopContext.currentShop().id;
    const params : GetAllAgenciesParams = {
      skipCount,
      maxResultCount: 20,
      searchString: this.searchValue,
      sorting: 'name',
      storeId: this.filter.isAgencyFilterNotByStore ? null : storeId
    }
    this.agencyService.getAllAgencies(this.loaderId,params)
    .subscribe(res => {
        this.dataToView = res.items.map(el => FilterMapper.AgencyFilter(el, this.filter.isAgencyFilterNotByStore ? true : false));
        this.totalCount = res.totalCount + 1;
      });
  }

  getNextData(skipCount: number) {
    if (this.totalCount > skipCount) {
      const next = skipCount ? skipCount - 1 : skipCount;
      this.setDataToView(next);
    }
  }

}
